// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.menu-bar_menu-bar_mHbUn {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 0.5rem;

  /*
        For most things, we shouldn't explicitly set height, and let the
        content push the element to whatever fits. Using a fixed height
        instead, will help us subtract the value we assign from the body,
        adding up to a perfect 100%. This means we don't need to set
        overflow: hidden, which makes it hard to debug. border-box
        simplifies by all of this by removing padding from the equation.
    */
  box-sizing: border-box;
  height: 3rem;

  /*
        @todo: This adds ~20px in Chrome, when scrolling to the right,
        but fixes [FFx + Safari] [resize window down + scroll to the right] bug.
    */
  width: 100%;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 0.75rem;
  font-weight: bold;
  background-color: var(--menu-bar-background);
  background-image: var(--menu-bar-background-image);
  color: var(--menu-bar-foreground);
}

.menu-bar_dropdownCaret_iTnU9 {
  filter: var(--icon-style);
}

.menu-bar_main-menu_pHO0P {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
  flex-grow: 1;
  gap: 0.5rem;
  z-index: 491;
  background-color: transparent;
  -webkit-app-region: drag;
}

:root[data-is-scratch-desktop='true'] [class*='menu-bar_menu-bar'] {
  z-index: 9999;
}

.menu-bar_menuGroup_CIXJl {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.5rem;
  -webkit-app-region: no-drag;
  transition: opacity 0.3s ease;
}

/* 长按拖拽模式：整体半透明、可拖拽窗口 */

.menu-bar_menuGroup_CIXJl.menu-bar_drag-mode_PiHvY {
  opacity: 0.5;
  -webkit-app-region: drag;
}

.menu-bar_menuGroup_CIXJl.menu-bar_drag-mode_PiHvY .menu-bar_menu-bar-item_AoQo9 {
  -webkit-app-region: drag;
}

.menu-bar_inactive_APqeg {
  opacity: 0;
}

.menu-bar_scratch-logo_JC9W8 {
  height: 1.6rem;
  vertical-align: middle;
}

.menu-bar_scratch-logo_JC9W8.menu-bar_clickable_lANre {
  cursor: pointer;
}

.menu-bar_menu-bar-item_AoQo9 {
  display: flex;
  text-decoration: none;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  align-self: center;
  position: relative;
  align-items: center;
  white-space: nowrap;
  height: 3rem;
  -webkit-app-region: no-drag;
  padding: 0 5px;
}

.menu-bar_menu-bar-item_AoQo9.menu-bar_hoverable_O4JM1 {
  cursor: pointer;
}

.menu-bar_menu-bar-item_AoQo9.menu-bar_active_CxG9A,
.menu-bar_menu-bar-item_AoQo9.menu-bar_hoverable_O4JM1:hover {
  background-color: var(--ui-black-transparent);
}

.menu-bar_menu-bar-item_AoQo9.menu-bar_growable_G1Fy8 {
  /*max-width: \$menu-bar-item-max-width;*/
  flex: 1;
}

.menu-bar_title-field-growable_d4aev {
  flex-grow: 1;
  width: 2rem;
}

.menu-bar_file-group_jsHxa {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}

.menu-bar_file-group_jsHxa .menu-bar_menu-bar-item_AoQo9 {
  padding: 0 0.5rem;
}

.menu-bar_menu-bar-menu_cPn87 {
  margin-top: 3rem;
  z-index: 491;
}

.menu-bar_feedback-link_SD7ny {
  color: var(--menu-bar-background);
  text-decoration: none;
}

.menu-bar_feedback-button_DzR4T {
  background-color: var(--menu-bar-feedback);
  color: inherit;
  height: 34px;
}

.menu-bar_divider_mMopV {
  height: 34px;
}

.menu-bar_author-info_rNAMH {
  margin-left: 0.25rem;
  margin-right: 0.6875rem;
}

.menu-bar_menu-bar-button_CptJx {
  height: 2rem;
}

.menu-bar_remix-button_xdVwQ {
  background-color: var(--pen-primary);
}

.menu-bar_remix-button-icon_X6kcs {
  height: 1.25rem;
}

.menu-bar_coming-soon_OILR0 > :not(.menu-bar_coming-soon-tooltip_TIPUP) {
  opacity: 0.5;
}

.menu-bar_account-info-group_hCKZ1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  -webkit-app-region: no-drag;
  height: 100%;
}

.menu-bar_account-info-group_hCKZ1 .menu-bar_menu-bar-item_AoQo9 {
  margin: 0 0.25rem;
  padding: 0 0.75rem;
}

.menu-bar_mystuff-icon_jVWTU {
  margin: 0 0.25rem;
  height: 1rem;
}

.menu-bar_help-icon_VsnHI {
  margin: 0 0.25rem 0 0;
}

[dir='rtl'] .menu-bar_help-icon_VsnHI {
  margin: 0 0 0 0.25rem;
}

.menu-bar_account-nav-menu_e33tH,
.menu-bar_mystuff-button_rrYLw {
  padding: 0 0.25rem;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.menu-bar_profile-icon_ayYUl {
  margin: 0 0.25rem;
  width: 2rem;
  border-radius: calc(0.5rem / 2);
}

.menu-bar_dropdown-caret-icon_GBcap {
  width: 0.5rem;
  height: 0.5rem;
}

[dir='ltr'] .menu-bar_dropdown-caret-icon_GBcap {
  margin-left: 0.5rem;
}

[dir='rtl'] .menu-bar_dropdown-caret-icon_GBcap {
  margin-right: 0.5rem;
}

.menu-bar_disabled_IMRqW {
  opacity: 0.5;
}

.menu-bar_mystuff_k028c > a {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 45%;
  padding-right: 10px;
  padding-left: 10px;
  width: 30px;
  overflow: hidden;
  text-indent: 50px;
  white-space: nowrap;
}

.menu-bar_mystuff_k028c > a:hover {
  background-size: 50%;
}

.menu-bar_mystuff_k028c > a {
  /* background-image: url("/images/mystuff.png"); */
}

.menu-bar_about-icon_AJM3M {
  height: 1.25rem;
  margin: 0.5rem;
  vertical-align: middle;
}

.menu-bar_collapsible-label_o1JjP {
  margin: 0 0.25rem;
}

@media only screen and (max-width: 1124px) {
  .menu-bar_tutorials-label_xQoKM,
  .menu-bar_collapsible-label_o1JjP {
    display: none;
  }

  .menu-bar_help-icon_VsnHI {
    margin-right: 0;
  }

  .menu-bar_Icon_yGkWC {
    width: 20px !important;
    height: auto !important;
  }
}

.menu-bar_menu-item-link_exwIT {
  color: inherit;
  text-decoration: none;
}

.menu-bar_control-bar_ALPyO {
  position: relative;
  height: 3rem;
  pointer-events: none;
}

.menu-bar_controlBarInner_V3voO {
  /* position: fixed; */
  top: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  height: 3rem;
  padding-left: 18px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 0.75rem;
  font-weight: bold;
  background-color: transparent;
  color: var(--menu-bar-foreground);
  -webkit-app-region: drag;
  pointer-events: auto;
  z-index: 491;
}

.menu-bar_controlBarInner_V3voO > * {
  pointer-events: auto;
  flex-shrink: 0;
}

.menu-bar_Icon_yGkWC {
  filter: var(--icon-style);
  width: 20px;
  height: auto;
}

.menu-bar_controlButton_owjhx {
  width: 46px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  -webkit-app-region: none;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  background-color: transparent;
}

.menu-bar_controlButton_owjhx:hover {
  background-color: #ffffff20;
}
`, "",{"version":3,"sources":["webpack://./src/components/menu-bar/menu-bar.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,WAAW;;EAEX;;;;;;;KAOG;EACH,sBAAsB;EACtB,YAAY;;EAEZ;;;KAGG;EACH,WAAW;EACX,2DAA2D;EAC3D,kBAAkB;EAClB,iBAAiB;EACjB,4CAA4C;EAC5C,kDAAkD;EAClD,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,uBAAuB;;AAEvB;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,uCAAuC;EACvC,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,MAAM;EACN,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,2DAA2D;EAC3D,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,iCAAiC;EACjC,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.menu-bar {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  gap: 0.5rem;\n\n  /*\n        For most things, we shouldn't explicitly set height, and let the\n        content push the element to whatever fits. Using a fixed height\n        instead, will help us subtract the value we assign from the body,\n        adding up to a perfect 100%. This means we don't need to set\n        overflow: hidden, which makes it hard to debug. border-box\n        simplifies by all of this by removing padding from the equation.\n    */\n  box-sizing: border-box;\n  height: 3rem;\n\n  /*\n        @todo: This adds ~20px in Chrome, when scrolling to the right,\n        but fixes [FFx + Safari] [resize window down + scroll to the right] bug.\n    */\n  width: 100%;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-size: 0.75rem;\n  font-weight: bold;\n  background-color: var(--menu-bar-background);\n  background-image: var(--menu-bar-background-image);\n  color: var(--menu-bar-foreground);\n}\n\n.dropdownCaret {\n  filter: var(--icon-style);\n}\n\n.main-menu {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  flex-wrap: nowrap;\n  align-items: center;\n  flex-grow: 1;\n  gap: 0.5rem;\n  z-index: 491;\n  background-color: transparent;\n  -webkit-app-region: drag;\n}\n\n:root[data-is-scratch-desktop='true'] [class*='menu-bar_menu-bar'] {\n  z-index: 9999;\n}\n\n.menuGroup {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 0.5rem;\n  -webkit-app-region: no-drag;\n  transition: opacity 0.3s ease;\n}\n\n/* 长按拖拽模式：整体半透明、可拖拽窗口 */\n\n.menuGroup.drag-mode {\n  opacity: 0.5;\n  -webkit-app-region: drag;\n}\n\n.menuGroup.drag-mode .menu-bar-item {\n  -webkit-app-region: drag;\n}\n\n.inactive {\n  opacity: 0;\n}\n\n.scratch-logo {\n  height: 1.6rem;\n  vertical-align: middle;\n}\n\n.scratch-logo.clickable {\n  cursor: pointer;\n}\n\n.menu-bar-item {\n  display: flex;\n  text-decoration: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  align-self: center;\n  position: relative;\n  align-items: center;\n  white-space: nowrap;\n  height: 3rem;\n  -webkit-app-region: no-drag;\n  padding: 0 5px;\n}\n\n.menu-bar-item.hoverable {\n  cursor: pointer;\n}\n\n.menu-bar-item.active,\n.menu-bar-item.hoverable:hover {\n  background-color: var(--ui-black-transparent);\n}\n\n.menu-bar-item.growable {\n  /*max-width: $menu-bar-item-max-width;*/\n  flex: 1;\n}\n\n.title-field-growable {\n  flex-grow: 1;\n  width: 2rem;\n}\n\n.file-group {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.file-group .menu-bar-item {\n  padding: 0 0.5rem;\n}\n\n.menu-bar-menu {\n  margin-top: 3rem;\n  z-index: 491;\n}\n\n.feedback-link {\n  color: var(--menu-bar-background);\n  text-decoration: none;\n}\n\n.feedback-button {\n  background-color: var(--menu-bar-feedback);\n  color: inherit;\n  height: 34px;\n}\n\n.divider {\n  height: 34px;\n}\n\n.author-info {\n  margin-left: 0.25rem;\n  margin-right: 0.6875rem;\n}\n\n.menu-bar-button {\n  height: 2rem;\n}\n\n.remix-button {\n  background-color: var(--pen-primary);\n}\n\n.remix-button-icon {\n  height: 1.25rem;\n}\n\n.coming-soon > :not(.coming-soon-tooltip) {\n  opacity: 0.5;\n}\n\n.account-info-group {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  -webkit-app-region: no-drag;\n  height: 100%;\n}\n\n.account-info-group .menu-bar-item {\n  margin: 0 0.25rem;\n  padding: 0 0.75rem;\n}\n\n.mystuff-icon {\n  margin: 0 0.25rem;\n  height: 1rem;\n}\n\n.help-icon {\n  margin: 0 0.25rem 0 0;\n}\n\n[dir='rtl'] .help-icon {\n  margin: 0 0 0 0.25rem;\n}\n\n.account-nav-menu,\n.mystuff-button {\n  padding: 0 0.25rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.profile-icon {\n  margin: 0 0.25rem;\n  width: 2rem;\n  border-radius: calc(0.5rem / 2);\n}\n\n.dropdown-caret-icon {\n  width: 0.5rem;\n  height: 0.5rem;\n}\n\n[dir='ltr'] .dropdown-caret-icon {\n  margin-left: 0.5rem;\n}\n\n[dir='rtl'] .dropdown-caret-icon {\n  margin-right: 0.5rem;\n}\n\n.disabled {\n  opacity: 0.5;\n}\n\n.mystuff > a {\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 45%;\n  padding-right: 10px;\n  padding-left: 10px;\n  width: 30px;\n  overflow: hidden;\n  text-indent: 50px;\n  white-space: nowrap;\n}\n\n.mystuff > a:hover {\n  background-size: 50%;\n}\n\n.mystuff > a {\n  /* background-image: url(\"/images/mystuff.png\"); */\n}\n\n.about-icon {\n  height: 1.25rem;\n  margin: 0.5rem;\n  vertical-align: middle;\n}\n\n.collapsible-label {\n  margin: 0 0.25rem;\n}\n\n@media only screen and (max-width: 1124px) {\n  .tutorials-label,\n  .collapsible-label {\n    display: none;\n  }\n\n  .help-icon {\n    margin-right: 0;\n  }\n\n  .Icon {\n    width: 20px !important;\n    height: auto !important;\n  }\n}\n\n.menu-item-link {\n  color: inherit;\n  text-decoration: none;\n}\n\n.control-bar {\n  position: relative;\n  height: 3rem;\n  pointer-events: none;\n}\n\n.controlBarInner {\n  /* position: fixed; */\n  top: 0;\n  right: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  height: 3rem;\n  padding-left: 18px;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-size: 0.75rem;\n  font-weight: bold;\n  background-color: transparent;\n  color: var(--menu-bar-foreground);\n  -webkit-app-region: drag;\n  pointer-events: auto;\n  z-index: 491;\n}\n\n.controlBarInner > * {\n  pointer-events: auto;\n  flex-shrink: 0;\n}\n\n.Icon {\n  filter: var(--icon-style);\n  width: 20px;\n  height: auto;\n}\n\n.controlButton {\n  width: 46px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 16px;\n  -webkit-app-region: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  background-color: transparent;\n}\n\n.controlButton:hover {\n  background-color: #ffffff20;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu-bar": `menu-bar_menu-bar_mHbUn`,
	"menuBar": `menu-bar_menu-bar_mHbUn`,
	"dropdownCaret": `menu-bar_dropdownCaret_iTnU9`,
	"main-menu": `menu-bar_main-menu_pHO0P`,
	"mainMenu": `menu-bar_main-menu_pHO0P`,
	"menuGroup": `menu-bar_menuGroup_CIXJl`,
	"drag-mode": `menu-bar_drag-mode_PiHvY`,
	"dragMode": `menu-bar_drag-mode_PiHvY`,
	"menu-bar-item": `menu-bar_menu-bar-item_AoQo9`,
	"menuBarItem": `menu-bar_menu-bar-item_AoQo9`,
	"inactive": `menu-bar_inactive_APqeg`,
	"scratch-logo": `menu-bar_scratch-logo_JC9W8`,
	"scratchLogo": `menu-bar_scratch-logo_JC9W8`,
	"clickable": `menu-bar_clickable_lANre`,
	"hoverable": `menu-bar_hoverable_O4JM1`,
	"active": `menu-bar_active_CxG9A`,
	"growable": `menu-bar_growable_G1Fy8`,
	"title-field-growable": `menu-bar_title-field-growable_d4aev`,
	"titleFieldGrowable": `menu-bar_title-field-growable_d4aev`,
	"file-group": `menu-bar_file-group_jsHxa`,
	"fileGroup": `menu-bar_file-group_jsHxa`,
	"menu-bar-menu": `menu-bar_menu-bar-menu_cPn87`,
	"menuBarMenu": `menu-bar_menu-bar-menu_cPn87`,
	"feedback-link": `menu-bar_feedback-link_SD7ny`,
	"feedbackLink": `menu-bar_feedback-link_SD7ny`,
	"feedback-button": `menu-bar_feedback-button_DzR4T`,
	"feedbackButton": `menu-bar_feedback-button_DzR4T`,
	"divider": `menu-bar_divider_mMopV`,
	"author-info": `menu-bar_author-info_rNAMH`,
	"authorInfo": `menu-bar_author-info_rNAMH`,
	"menu-bar-button": `menu-bar_menu-bar-button_CptJx`,
	"menuBarButton": `menu-bar_menu-bar-button_CptJx`,
	"remix-button": `menu-bar_remix-button_xdVwQ`,
	"remixButton": `menu-bar_remix-button_xdVwQ`,
	"remix-button-icon": `menu-bar_remix-button-icon_X6kcs`,
	"remixButtonIcon": `menu-bar_remix-button-icon_X6kcs`,
	"coming-soon": `menu-bar_coming-soon_OILR0`,
	"comingSoon": `menu-bar_coming-soon_OILR0`,
	"coming-soon-tooltip": `menu-bar_coming-soon-tooltip_TIPUP`,
	"comingSoonTooltip": `menu-bar_coming-soon-tooltip_TIPUP`,
	"account-info-group": `menu-bar_account-info-group_hCKZ1`,
	"accountInfoGroup": `menu-bar_account-info-group_hCKZ1`,
	"mystuff-icon": `menu-bar_mystuff-icon_jVWTU`,
	"mystuffIcon": `menu-bar_mystuff-icon_jVWTU`,
	"help-icon": `menu-bar_help-icon_VsnHI`,
	"helpIcon": `menu-bar_help-icon_VsnHI`,
	"account-nav-menu": `menu-bar_account-nav-menu_e33tH`,
	"accountNavMenu": `menu-bar_account-nav-menu_e33tH`,
	"mystuff-button": `menu-bar_mystuff-button_rrYLw`,
	"mystuffButton": `menu-bar_mystuff-button_rrYLw`,
	"profile-icon": `menu-bar_profile-icon_ayYUl`,
	"profileIcon": `menu-bar_profile-icon_ayYUl`,
	"dropdown-caret-icon": `menu-bar_dropdown-caret-icon_GBcap`,
	"dropdownCaretIcon": `menu-bar_dropdown-caret-icon_GBcap`,
	"disabled": `menu-bar_disabled_IMRqW`,
	"mystuff": `menu-bar_mystuff_k028c`,
	"about-icon": `menu-bar_about-icon_AJM3M`,
	"aboutIcon": `menu-bar_about-icon_AJM3M`,
	"collapsible-label": `menu-bar_collapsible-label_o1JjP`,
	"collapsibleLabel": `menu-bar_collapsible-label_o1JjP`,
	"tutorials-label": `menu-bar_tutorials-label_xQoKM`,
	"tutorialsLabel": `menu-bar_tutorials-label_xQoKM`,
	"Icon": `menu-bar_Icon_yGkWC`,
	"icon": `menu-bar_Icon_yGkWC`,
	"menu-item-link": `menu-bar_menu-item-link_exwIT`,
	"menuItemLink": `menu-bar_menu-item-link_exwIT`,
	"control-bar": `menu-bar_control-bar_ALPyO`,
	"controlBar": `menu-bar_control-bar_ALPyO`,
	"controlBarInner": `menu-bar_controlBarInner_V3voO`,
	"controlButton": `menu-bar_controlButton_owjhx`
};
export default ___CSS_LOADER_EXPORT___;
